//To animate the numbers


function animateNumbers() {

	function animateCounter(obj, start, end, duration) {

		if (end % 1 != 0) {
			let decimal = end % 1;
			//its a decimal and need to do something
			let startTimestamp = null;
			const step = (timestamp) => {

				if (!startTimestamp) startTimestamp = timestamp;
				const progress = Math.min((timestamp - startTimestamp) / duration, 1);

				let decimal_progress = 0;

				if (progress < 1) {
					window.requestAnimationFrame(step);
				}

				if (progress === Math.floor(end)) {
					decimal_progress = Math.min((timestamp - startTimestamp) / duration, 1);
				}

				obj.innerHTML = Math.floor(progress * (end - start) + start) + '.' + Math.floor(decimal_progress * ((decimal * 10) - start) + start);
			};
			window.requestAnimationFrame(step);

		} else {
			let startTimestamp = null;
			const step = (timestamp) => {

				if (!startTimestamp) startTimestamp = timestamp;
				const progress = Math.min((timestamp - startTimestamp) / duration, 1);

				obj.innerHTML = Math.floor(progress * (end - start) + start);
				if (progress < 1) {
					window.requestAnimationFrame(step);
				}
			};
			window.requestAnimationFrame(step);
		}

	}

	const objs = document.getElementsByClassName("animated-number");

	for (let i = 0; i < objs.length; i++) {
		let obj = objs[i];
		let count = obj.innerHTML;
		animateCounter(obj, 0, count, 3000);
	}

}

let animated = false;
//only want numbers to animate when block comes into view
window.addEventListener('scroll', function () {
	var element = document.getElementsByClassName('animated-number')[0];
	if (element != null) {
		var position = element.getBoundingClientRect();
		// checking for visibility
		if (animated == false && position.top < window.innerHeight - 250 && position.bottom >= 0) {
			//only want it to run once
			animated = true;
			animateNumbers();
		}
	}
});
